import { useEffect } from "react";

/**
 * Asks the browser to confirm a tab close or reload while `shouldBlock` holds.
 *
 * The tab-close half of {@link useUnsavedWorkspaceGuard}, on its own for
 * surfaces whose in-app navigation must stay free — the new-rule conversation
 * hands off to the rule it creates with a search change, which a router
 * blocker would stop.
 */
export const useBeforeUnloadGuard = (shouldBlock: boolean) => {
  useEffect(() => {
    if (!shouldBlock) {
      return;
    }
    const onBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [shouldBlock]);
};
